export default "__VITE_ASSET__1ceea948__"